export default "__VITE_ASSET__BXw03UBr__";